import React from 'react';
import Navbar from '../components/Navbar';
import ChatbotButton from '../components/ChatbotButton';
import '../styles/transactions.css';

const transactions = {
  Today: [
    {
      title: 'Medical Consultation',
      ministry: 'Ministry of Health',
      cost: 'OMR 25.00',
    },
    {
      title: 'School Fees',
      ministry: 'Ministry of Education',
      cost: 'OMR 150.00',
    },
  ],
  Yesterday: [
    {
      title: 'Vehicle Registration',
      ministry: 'Ministry of Transport',
      cost: 'OMR 50.00',
    },
    {
      title: 'Business License Renewal',
      ministry: 'Ministry of Commerce',
      cost: 'OMR 100.00',
    },
  ],
  'May 15, 2024': [
    {
      title: 'Property Tax Payment',
      ministry: 'Ministry of Housing',
      cost: 'OMR 200.00',
    },
    {
      title: 'Work Permit Application',
      ministry: 'Ministry of Manpower',
      cost: 'OMR 75.00',
    },
  ],
};

const TransactionsPage = () => {
  return (
    <div className="transactions-container">
      <Navbar />
      <div className="transactions-wrapper">
        {Object.entries(transactions).map(([date, entries]) => (
          <div key={date}>
            <h3 className="transaction-date">{date}</h3>
            {entries.map((item, idx) => (
              <div className="transaction-entry" key={idx}>
                <div>
                  <strong>{item.title}</strong>
                  <div className="transaction-ministry">{item.ministry}</div>
                </div>
                <div className="transaction-cost">{item.cost}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <ChatbotButton />
    </div>
  );
};

export default TransactionsPage;
